import axios from 'axios';
import { GetEnvironmentConfig } from "../App.Config";

export const postIncidentAsync = async (incident: any) => {
    try{
        await axios.post(`/api/v1/incident`, incident);
    }
    catch(error){
        throw error;
    }
}

export const postUserAsync = async (user: any) => {
    try{
        await axios.post(`/api/v1/user`, user);
    }
    catch(error){
        throw error;
    }
}